<template>
  <div class="ai-visibility-score-bar" :class="`ai-visibility-score-bar--${tone}`">
    <div class="ai-visibility-score-bar__track" :class="{'ai-visibility-score-bar__wide': wide}">
      <span class="ai-visibility-score-bar__fill" :style="{ width: `${percentage}%` }"></span>
    </div>
    <span v-if="showValue" class="ai-visibility-score-bar__value">{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'ScoreBar',
  props: {
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: 100,
    },
    tone: {
      type: String,
      default: 'primary',
    },
    showValue: {
      type: Boolean,
      default: true,
    },
     wide: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    percentage () {
      if (!this.max) {
        return 0
      }
      return Math.max(0, Math.min(100, (this.value / this.max) * 100))
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-score-bar {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ai-visibility-score-bar__track {
  overflow: hidden;
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: var(--v-gray10Color-base);
}

.ai-visibility-score-bar__wide {
  height: 16px;
}

.ai-visibility-score-bar__fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--v-blackColor-base);
}

.ai-visibility-score-bar--success .ai-visibility-score-bar__fill {
  background: var(--v-green7Color-base);
}

.ai-visibility-score-bar--danger .ai-visibility-score-bar__fill {
  background: var(--v-red11Color-base);
}

.ai-visibility-score-bar--neutral .ai-visibility-score-bar__fill {
  background: var(--v-gray36Color-base);
}

.ai-visibility-score-bar__value {
  min-width: 28px;
  color: var(--v-blackColor-base);
  font-size: 16px;
  font-weight: 800;
  text-align: right;
}
</style>
